import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

/**
 * Loads reCAPTCHA for the subtree that actually needs it.
 *
 * This provider used to sit in App.js, wrapping <Container /> - i.e. every route.
 * Only two screens call useGoogleReCaptcha: the public booking page and the
 * register screen. Wrapping the whole app meant Google's script was fetched on
 * every page load for every user, and - once the site key was switched from a
 * dead v2 key to a working v3 one - v3's fixed bottom-right badge rendered on
 * every screen in the product, on top of whatever sat in that corner.
 *
 * Wrap the two screens that need it instead. useGoogleReCaptcha must be called
 * from inside the provider, so each screen is wrapped at its export rather than
 * from within its own body.
 */
const ReCaptchaScope = ({ children }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_SITE_KEY}
    scriptProps={{
      async: false,
      defer: false,
      appendTo: "head",
      nonce: undefined,
    }}
  >
    {children}
  </GoogleReCaptchaProvider>
);

export default ReCaptchaScope;
